import { makeRemoteInvoice } from "../../../../../../main/factories/usecases/invoice/remote-invoice-factory";

const fetchInvoicePDF = async (docId: number): Promise<Blob> => makeRemoteInvoice().pdf(docId);

export default fetchInvoicePDF;
